$(document).on('turbo:load', () => {
    $("#user_role_individual").on('click', ()=> {
      window.location.href = '/register/profile/edit?role=individual'
    });
    $("#user_role_entity").on('click', ()=> {
        window.location.href = '/register/profile/edit?role=entity'
    });
    $("#user_role_manager").on('click', ()=> {
        window.location.href = '/register/profile/edit?role=manager'
    });
});

